// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/BusinessRule.yaml
// Generated: 2026-02-17T15:38:20.353Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateBusinessRule, UpdateBusinessRule, BusinessRule } from '@/types/core/BusinessRule';

/**
 * BusinessRule Service
 * CRUD operations for BusinessRule via the ABP API.
 */
export const businessRuleService = new EntityService<BusinessRule, CreateBusinessRule, UpdateBusinessRule>(
  '/api/core/businessrule',
  'BusinessRule',
);
